import React from "react";
import {
  Alert,
  Box,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

export default function ImportSampleStep({ draft }) {
  const headers = draft?.headers || [];
  const rows = draft?.sampleRows || [];

  return (
    <Box>
      <Typography variant="h6" sx={{ fontWeight: 900, mb: 0.5 }}>Encabezados y muestra</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Detectamos {headers.length} columna(s) y {draft?.rowCount || 0} fila(s). Revisá que la primera fila haya sido interpretada correctamente antes de mapear.
      </Typography>
      <Alert severity="info" sx={{ mb: 2 }}>
        Fuente: {draft?.source?.fileName || draft?.source?.url || "importación"}
        {draft?.source?.format ? <> · <Chip size="small" label={draft.source.format.toUpperCase()} sx={{ ml: 1 }} /></> : null}
      </Alert>
      <TableContainer sx={{ maxHeight: 360, border: "1px solid", borderColor: "divider", borderRadius: 2 }}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              {headers.map((header) => (
                <TableCell key={header} sx={{ fontWeight: 900, whiteSpace: "nowrap" }}>{header}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, rowIndex) => (
              <TableRow key={rowIndex}>
                {headers.map((header, columnIndex) => (
                  <TableCell key={`${rowIndex}-${header}`} sx={{ maxWidth: 260 }}>
                    <Typography variant="body2" noWrap title={String(row?.[columnIndex] ?? "")}>
                      {String(row?.[columnIndex] ?? "") || "—"}
                    </Typography>
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
